import { map, values } from "lodash";

export const PatientWeightUnits = {
    "lb": "pounds",
    "kg": "kilograms",
    "oz": "ounces",
    "gm": "grams"
}

export const patientWeightUnitNames = values(PatientWeightUnits);

export const patientWeightUnitList = [
    {
        "name": "pounds",
        "abbr": "lb"
    },
    {
        "name": "kilograms",
        "abbr": "kg"
    },
    {
        "name": "ounces",
        "abbr": "oz"
    },
    {
        "name": "grams",
        "abbr": "gm"
    },
];

export const patientWeightUnitsDropdownList = map(patientWeightUnitList, pwUnit => (
    { name: pwUnit.name, value: pwUnit.name }
));
